module.exports = "/shared/fonts/proxima-nova-semibold.otf";


//////////////////
// WEBPACK FOOTER
// ./src/ui/fonts/proxima-nova-semibold.otf
// module id = 18
// module chunks = 13